import { AvatarMenuTab } from '../enums';
import { AvatarMenu } from '../models';

export const AVATAR_MENU_CONFIG: AvatarMenu[] = [
    { menuName: 'general.practice', menuTab: AvatarMenuTab.Practice },
    { menuName: 'general.password', menuTab: AvatarMenuTab.Password },
    { menuName: 'general.payment', menuTab: AvatarMenuTab.Payment },
    { menuName: 'general.rewardStatus', menuTab: AvatarMenuTab.RewardStatus },
    { menuName: 'general.credit', menuTab: AvatarMenuTab.Credit },
];
